import { type Summary, formatSeconds, formatMeters } from './derive';
import { DataPlaceholder } from './DataPlaceholder';
import { palette } from './palette';

export function ActivitySummaryStrip({ summary }: { summary: Summary }) {
  const avgTravel = formatSeconds(summary.avgTravelSeconds);
  const distance = formatMeters(summary.totalDistanceMeters);
  const items: { label: string; value: React.ReactNode; sub?: string }[] = [
    { label: 'DISPATCHES', value: summary.dispatches },
    { label: 'TASKS STARTED', value: summary.tasksStarted },
    { label: 'RECENT STOPS', value: summary.recentStops },
    { label: 'AVG TRAVEL', value: avgTravel ?? <DataPlaceholder />, sub: 'between waypoints' },
    { label: 'DISTANCE TRAVELED', value: distance ?? <DataPlaceholder /> },
  ];
  return (
    <div
      className="rounded-xl px-4 py-[14px]"
      style={{ background: palette.bgAlt }}
    >
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {items.map((i) => (
          <div key={i.label}>
            <div className="text-[9px] font-bold tracking-[0.14em] text-muted">{i.label}</div>
            <div className="mt-1 text-[22px] font-extrabold tracking-tight tabular-nums">
              {i.value}
            </div>
            {i.sub && <div className="mt-0.5 text-[10px] text-muted">{i.sub}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
